export default function getTabRouteName (tab) {
  switch (tab) {
    case 'reports': return 'LensReports'
    case 'creative-tests': return 'LensCreativeTests'
    case 'inspiration': return 'LensInspiration'
    case 'comments': return 'LensComments'
    case 'spend-back': return 'LensSpendBack'
    default: return 'LensDashboardView'
  }
}